import { ButtonPromo, ButtonSwitch, Currency, Divider, Link, StepCSSTransitionGroup } from "@wg/wows-react-uikit";
import get from "lodash/get";
import React, { Fragment, PureComponent } from "react";
import { Interpolate } from "react-i18next";
import dwhExport from '~/dwhExport';
import { getCompetitionMetricPoints } from "../../../../helpers/cwars";
import { t, x } from "../../../../helpers/localization";
import { IStages, IWarSettings } from "../../../../Reducers/ReducerClanWars";
import { COMPETITION_METRIC } from "../../../UIKit/UIKit";
import Calendar from "../../Calendar/Calendar";
import ProgressBar from "../../ProgressBar/ProgressBar";
import MyWarTable from "../MyWarTab/MyWarTable/MyWarTable";
import styles from "./RulesTab.scss";

export type RulesTab_Props = {
  stages: IStages;
  warSettings: IWarSettings;
  clanId?: number;

  navigateToRecommendations: () => void;
};
export type RulesTab_State = {
  progressPersonalProgress: number;
  progressClanProgress: number;
  progressMaxClanProgress: number;
  progressMaxPersonalProgress: number;
  useAttempts: boolean;
  isFullRules: boolean;
};

const clanProgressMilestones = [{
  reward: {
    title: 'string',
    type: 'oil',
    description: 'description',
    imageUrl: null,
    amount: 50
  },
  value: 10000
}, {
  reward: {
    title: 'string',
    type: 'oil',
    description: 'description',
    imageUrl: null,
    amount: 150
  },
  value: 25000
}, {
  reward: {
    title: 'string',
    type: 'oil',
    description: 'description',
    imageUrl: null,
    amount: 250
  },
  value: 50000
}, {
  reward: {
    title: 'string',
    type: 'oil',
    description: 'description',
    imageUrl: null,
    amount: 350
  },
  value: 100000
}];

const maxClanReward = 800;
class RulesTab extends PureComponent<RulesTab_Props, RulesTab_State> {


  state = {
    progressPersonalProgress: 0,
    progressClanProgress: 0,
    progressMaxClanProgress: 100000,
    progressMaxPersonalProgress: 40000,
    useAttempts: false,
    isFullRules: false
  };

  _isMounted = false;

  showFullRules = () => {
    this.setState({
      isFullRules: true
    });
  };

  animateProgress = () => {
    let newPersonal = Math.floor(this.state.progressPersonalProgress + this.state.progressMaxClanProgress / 135);
    let newClan = Math.floor(this.state.progressClanProgress + this.state.progressMaxClanProgress / 50);

    if (this._isMounted) {
      this.setState({
        progressPersonalProgress: newPersonal,
        progressClanProgress: newClan
      }, () => {
        if (this.state.progressClanProgress < this.state.progressMaxClanProgress) {
          setTimeout(() => {
            this.animateProgress();
          }, 750);
        } else {
          setTimeout(() => {
            this.setState({
              progressPersonalProgress: 0,
              progressClanProgress: 0
            }, this.animateProgress);
          }, 3500);
        }
      });
    }

  };

  setUseAttempts = () => {
    if (this._isMounted) {
      this.setState({
        useAttempts: !this.state.useAttempts
      }, () => {
        setTimeout(() => {
          this.setUseAttempts();
        }, 3000);
      });
    }
  };

  componentDidMount() {
    this._isMounted = true;
    dwhExport.send('naval_battles.view_rules')
    this.animateProgress();
    this.setUseAttempts();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getPreparationRewardSumm = () => {
    const milestones = get(this.props.warSettings, 'stages.preparation.clanProgressMilestones', null);
    let sum = 0;
    if (milestones) {
      milestones.forEach(milestone => {
        const amount = (milestone.reward && milestone.reward.amount) ? milestone.reward.amount : 0;
        sum += amount;
      });
    }

    return sum;
  };

  getProgressTarget = (maxClanProgress: number) => {
    switch (this.props.warSettings.stages.preparation.competitionMetric) {

      case COMPETITION_METRIC.EXP:
        {
          return <Interpolate i18nKey={x('Заработайте %(maxClanProgress)s чистого опыта.')} maxClanProgress={maxClanProgress} />;
        }

      case COMPETITION_METRIC.DAMAGE:
        {
          return <Interpolate i18nKey={x('Нанесите %(maxClanProgress)s урона.')} maxClanProgress={maxClanProgress} />;
        }

      case COMPETITION_METRIC.RIBBONS:
        {
          return <Interpolate i18nKey={x('Получите %(maxClanProgress)s лент.')} maxClanProgress={maxClanProgress} />;
        }

      default:
        {
          return <Interpolate i18nKey={x('Заработайте %(maxClanProgress)s чистого опыта.')} maxClanProgress={maxClanProgress} />;
        }

    }
  };

  getFullBattleDescrText = () => {
    switch (this.props.warSettings.stages.preparation.competitionMetric) {

      case COMPETITION_METRIC.EXP:
        {
          return t('Чтобы доказать свою силу и получить право сразиться с другими кланами, ваш клан должен выполнить боевую задачу - набрать определённое количество чистого опыта. Условия задачи зависят от общей численности клана, а выполнять её можно с понедельника по четверг. Максимальный вклад от каждого игрока ограничен. Поэтому, чем больше у вас активных игроков, тем проще выполнить общую боевую задачу.');
        }

      case COMPETITION_METRIC.DAMAGE:
        {
          return t('Чтобы доказать свою силу и получить право сразиться с другими кланами, ваш клан должен выполнить боевую задачу - нанести определённое количество урона. Условия задачи зависят от общей численности клана, а выполнять её можно с понедельника по четверг. Максимальный вклад от каждого игрока ограничен. Поэтому, чем больше у вас активных игроков, тем проще выполнить общую боевую задачу.');
        }

      case COMPETITION_METRIC.RIBBONS:
        {
          return t('Чтобы доказать свою силу и получить право сразиться с другими кланами, ваш клан должен выполнить боевую задачу - получить определённое количество лент. Условия задачи зависят от общей численности клана, а выполнять её можно с понедельника по четверг. Максимальный вклад от каждого игрока ограничен. Поэтому, чем больше у вас активных игроков, тем проще выполнить общую боевую задачу.');
        }

      default:
        {
          return '';
        }

    }
  };

  getFullStartBattleDescrText = () => {
    switch (this.props.warSettings.stages.preparation.competitionMetric) {

      case COMPETITION_METRIC.EXP:
        {
          return t('С началом битвы игроки клана получат доступ к специальной таблице. Каждая ячейка таблицы является отдельной категорией, представляющей ветку исследуемых кораблей. Для каждой доступна цепочка боевых задач, выполнять которую можно на исследуемых, премиумных и акционных кораблях. Условие для всех задач одинаковое: заработать определённое количество чистого опыта в случайных, кооперативных и ранговых боях. Наградой станет звезда для вашего клана.');
        }

      case COMPETITION_METRIC.DAMAGE:
        {
          return t('С началом битвы игроки клана получат доступ к специальной таблице. Каждая ячейка таблицы является отдельной категорией, представляющей ветку исследуемых кораблей. Для каждой доступна цепочка боевых задач, выполнять которую можно на исследуемых, премиумных и акционных кораблях. Условие для всех задач одинаковое: нанести определённое количество урона в случайных, кооперативных и ранговых боях. Наградой станет звезда для вашего клана.');
        }

      case COMPETITION_METRIC.RIBBONS:
        {
          return t('С началом битвы игроки клана получат доступ к специальной таблице. Каждая ячейка таблицы является отдельной категорией, представляющей ветку исследуемых кораблей. Для каждой доступна цепочка боевых задач, выполнять которую можно на исследуемых, премиумных и акционных кораблях. Условие для всех задач одинаковое: получить определённое количество лент в случайных, кооперативных и ранговых боях. Наградой станет звезда для вашего клана.');
        }

      default:
        {
          return '';
        }

    }
  };

  getFullDetailsText = () => {
    switch (this.props.warSettings.stages.preparation.competitionMetric) {

      case COMPETITION_METRIC.EXP:
        {
          return t('Если игроки одного клана выйдут отрядом на технике из одной категории, то результаты будут засчитываться в порядке возрастания. Допустим, сейчас в категории советских эсминцев стоит задача: заработать 1000 чистого опыта, а после усложнения задачи — 1100. Игроки сыграли в отряде из советских эсминцев: «Удалого» и «Ташкента». Игрок на «Удалом» получил за бой 1000 единиц чистого опыта, а его товарищ — 1050. Игрок на «Удалом» принёс звезду своему клану и открыл доступ к усложненной задаче. Результат «Ташкента» ниже, чем требуется по условиям усложненной задачи, и получается, что он потратил попытку впустую. Однако, если бы он заработал 1100 чистого опыта или больше, то оба игрока принесли бы звезды в зачёт клана.');
        }

      case COMPETITION_METRIC.DAMAGE:
        {
          return t('Если игроки одного клана выйдут отрядом на технике из одной категории, то результаты будут засчитываться в порядке возрастания. Допустим, сейчас в категории советских эсминцев стоит задача: нанести 10000 урона, а после усложнения задачи — 20000. Игроки сыграли в отряде из советских эсминцев: «Удалого» и «Ташкента». Игрок на «Удалом» нанёс за бой 10000 урона, а его товарищ — 15000. Игрок на «Удалом» принёс звезду своему клану и открыл доступ к усложненной задаче. Результат «Ташкента» ниже, чем требуется по условиям усложненной задачи, и получается, что он потратил попытку впустую. Однако, если бы он нанёс 20000 урона или больше, то оба игрока принесли бы звезды в зачёт клана.');
        }

      case COMPETITION_METRIC.RIBBONS:
        {
          return t('Если игроки одного клана выйдут отрядом на технике из одной категории, то результаты будут засчитываться в порядке возрастания. Допустим, сейчас в категории советских эсминцев стоит задача: получить 100 лент, а после усложнения задачи — 200. Игроки сыграли в отряде из советских эсминцев: «Удалого» и «Ташкента». Игрок на «Удалом» получил за бой 100 лент, а его товарищ — 150. Игрок на «Удалом» принёс звезду своему клану и открыл доступ к усложненной задаче. Результат «Ташкента» ниже, чем требуется по условиям усложненной задачи, и получается, что он потратил попытку впустую. Однако, если бы он получил 200 лент или больше, то оба игрока принесли бы звезды в зачёт клана.');
        }

      default:
        {
          return '';
        }

    }
  };

  renderFullRules = () => {
    let oilReward = this.getPreparationRewardSumm();
    if (oilReward === 0) {
      oilReward = 800;
    }
    return <Fragment>
                <Divider type="major" />
                <StepCSSTransitionGroup level={1}>
                    <div className={styles.fullRulesTitleWrapper}>
                        <h1 className={styles.bigTitle}>{t('Расширенный вариант правил')}</h1>
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={1}>
                    <div className={styles.paragraph}>
                        <span className={styles.paragraphTitle}>{t('Период проведения')}</span>
                        <p className={styles.paragraphText}>{t('«Морское сражение» - это новое соревнование для кланов. Оно проходит каждую неделю и состоит из нескольких этапов. Кланы готовятся к битве с понедельника по четверг, а сражаются друг с другом с пятницы по воскресенье.')}</p>
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={2}>
                    <div className={styles.demoComponent}>
                        <Calendar currentWeek={1} weeksCount={1} currentStage={'war'} currentRound={1} stages={this.props.warSettings.stages} />
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={2}>
                    <div className={styles.paragraph}>
                        <p className={`${styles.paragraphText} ${styles.descriptionText}`}>{t('В разделе «Морское сражение» есть календарь, в котором вы всегда можете увидеть расписание и текущий этап соревнования.')}</p>
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={3}>
                    <div className={styles.paragraph}>
                        <span className={styles.paragraphTitle}>{t('Как принять участие?')}</span>
                        <p className={styles.paragraphText}>{t('Участвовать в Морском сражении могут только клановые игроки. Командующий клана и заместители командующего могут зарегистрировать клан для участия в соревновании.')}</p>

                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={4}>
                    <div className={styles.paragraph}>
                        <span className={styles.paragraphTitle}>{t('Подготовка')}</span>
                        <p className={styles.paragraphText}>{this.getFullBattleDescrText()}</p>
                        <Interpolate className={styles.paragraphText} i18nKey={x('За выполнение задачи клан получает не только допуск к битве но и до %(reward)s на счет клана.')} reward={<Currency amount={maxClanReward} type={clanProgressMilestones[clanProgressMilestones.length - 1].reward.type} isBold={true} t={t} />} />

                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={5}>
                    <div className={styles.demoComponent}>
                        <ProgressBar title={t('Задача клана')} target={this.getProgressTarget(this.state.progressMaxClanProgress)} mPoints={getCompetitionMetricPoints(this.props.warSettings.stages.preparation.competitionMetric)} myValue={this.state.progressPersonalProgress} myValueMax={this.state.progressMaxPersonalProgress} totalValue={this.state.progressClanProgress} maxValue={this.state.progressMaxClanProgress} breakpoints={clanProgressMilestones} competitionMetric={'exp'} />
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={5}>
                    <div className={styles.paragraph}>
                        <p className={`${styles.paragraphText} ${styles.descriptionText}`}>{t('Свой вклад и прогресс выполнения общей задачи вы найдёте на вкладке «Подготовка» в разделе «Морское сражение».')}</p>
                    </div>
                </StepCSSTransitionGroup>

                <div className={styles.paragraph}>
                    <span className={styles.paragraphTitle}>{t('Битва')}</span>
                    <p className={styles.paragraphText}>{t('Кланы всех серверов, которые выполнили подготовительную задачу, соревнуются 1 на 1. В пары подбираются кланы со схожей активностью игроков. Этот этап «Морского сражения» длится с пятницы по воскресенье.')}</p>
                    <p className={styles.paragraphText}>{t('Задача клана: обойти своего оппонента по количеству заработанных звёзд.')}</p>
                    <p className={styles.paragraphText}>{this.getFullStartBattleDescrText()}</p>
                </div>

                <div className={styles.demoComponent}>
                    <MyWarTable nations={this.props.warSettings.stages.war.nations} grades={this.props.warSettings.stages.war.grades} topGradesIncrement={this.props.warSettings.stages.war.topGradesIncrement} unavailableCells={this.props.warSettings.stages.war.unavailableCells} data={[]} onCellClick={() => {}} competitionMetric={this.props.warSettings.stages.preparation.competitionMetric} />
                </div>
                <div className={styles.paragraph}>
                    <p className={styles.paragraphText}>{t('Для взятия планок у каждого игрока есть ограниченное количество попыток. ')}</p>
                    <p className={styles.paragraphText}>{t('Чтобы приступить к выполнению задач, игрок должен зайти в раздел «Морское сражение» во вкладке клана и нажать соответствующую кнопку. ')}</p>
                </div>

                <div className={styles.demoComponent}>
                    <div className={styles.switchWrapper}>
                        <ButtonSwitch value={this.state.useAttempts} onChange={() => {}} stateTextOn={[t('Включить'), t('Включено')]} stateTextOff={[t('Выключить'), t('Выключено')]} />
                    </div>
                </div>

                <div className={styles.paragraph}>
                    <p className={`${styles.paragraphText} ${styles.descriptionText}`}>{t('Нажимая эту кнопку, игрок соглашается с участием в битве, а его бои идут в зачёт и учитываются в общем результате клана.')}</p>
                </div>

                <div className={styles.paragraph}>
                    <p className={styles.paragraphText}>{t('Если игрок выполняет задачу, то он приносит звезду в актив своего клана. После удачного выполнения задача усложняется. За каждый бой, независимо от его результата, тратится попытка, а число их ограничено десятью для каждого игрока.')}</p>
                    <p className={styles.paragraphText}>{t('Итогом «Битвы» клана может быть победа, ничья и поражение. От этого зависит то, сколько нефти и очков специального рейтинга получит клан.')}</p>
                </div>

                <div className={styles.paragraph}>
                    <span className={styles.paragraphTitle}>{t('Награды')}</span>
                    <p className={styles.paragraphText}>{t('Нефть — основная награда соревнования «Морское сражение» является нефть, которую получат все участвующие кланы в зависимости от активности участия.')}</p>
                    <ul className={styles.rewardList}>
                        <li className={styles.rewardListItem}>
                            <Interpolate i18nKey={x('За этап подготовки клан получит до %(reward)s')} reward={<Currency amount={oilReward} type={'oil'} isBold={true} t={t} />} />
                        </li>
                        <li className={styles.rewardListItem}>
                            <Interpolate i18nKey={x('За победу над противником клан получит %(reward)s')} reward={<Currency amount={this.props.warSettings.stages.rewarding.roundResultRewards.victory.amount} type={this.props.warSettings.stages.rewarding.roundResultRewards.victory.type} isBold={true} t={t} />} />
                        </li>
                        <li className={styles.rewardListItem}>
                            <Interpolate i18nKey={x('За ничью -  %(reward)s')} reward={<Currency amount={this.props.warSettings.stages.rewarding.roundResultRewards.draw.amount} type={this.props.warSettings.stages.rewarding.roundResultRewards.draw.type} isBold={true} t={t} />} />
                        </li>
                        <li className={styles.rewardListItem}>
                            <Interpolate i18nKey={x('За поражение -  %(reward)s')} reward={<Currency amount={this.props.warSettings.stages.rewarding.roundResultRewards.defeat.amount} type={this.props.warSettings.stages.rewarding.roundResultRewards.defeat.type} isBold={true} t={t} />} />
                        </li>
                        <li className={styles.rewardListItem}>
                            <Interpolate i18nKey={x('За каждые %(stars)s клан получает %(oil)s')} stars={<Currency amount={this.props.warSettings.stages.war.rewardedStarsIncrement} isBold={true} type="cwars-star" t={t} />} oil={<Currency amount={this.props.warSettings.stages.war.starsIncrementReward.amount} isBold={true} type={'oil'} t={t} />} />
                        </li>
                    </ul>
                    <p className={styles.paragraphText}>{t('Заработанная на этапе «Подготовки», нефть будет начисляться сразу, а за «Битву» - после её окончания.')}</p>
                </div>

                <div className={styles.paragraph}>
                    <span className={styles.paragraphTitle}>{t('Рейтинг')}</span>
                    <p className={styles.paragraphText}>{t('Подбор соперников для «Битвы» делается на основе активности кланов, а так же специального рейтинга, посмотреть который можно в соответствующей вкладке раздела «Морское сражение». Это неубывающий рейтинг, прибавки к которому зависят от того, как успешно клан соревнуется на этапе битвы.')}</p>
                </div>

                <div className={styles.paragraph}>
                    <span className={styles.paragraphTitle}>{t('Некоторые детали')}</span>
                    <p className={styles.paragraphText}>{t('Игроки, вступившие в клан после окончания этапа «Подготовки», поучаствовать в «Битве» уже не смогут. Тем не менее, они смогут принять участие на следующей неделе.')}</p>
                    <p className={styles.paragraphText}>{t('Помните, что, если игрок покинет клан после того, как нажмёт кнопку «Засчитывать попытки», то звёзды, которые он принёс, останутся в клане.')}</p>
                    <p className={styles.paragraphText}>{this.getFullDetailsText()}</p>
                </div>

            </Fragment>;
  };

  getBattleDescrText = () => {
    switch (this.props.warSettings.stages.preparation.competitionMetric) {

      case COMPETITION_METRIC.EXP:
        {
          return x('Следующие %(dayCount)s дня соревнуйтесь с другим кланом в получении чистого опыта на кораблях разных классов и наций. Для этого у каждого игрока есть %(attemptCount)s попыток. Перед выходом в бой необходимо включить использование своих попыток над таблицей с результатами клана.');
        }

      case COMPETITION_METRIC.DAMAGE:
        {
          return x('Следующие %(dayCount)s дня соревнуйтесь с другим кланом в нанесении урона на кораблях разных классов и наций. Для этого у каждого игрока есть %(attemptCount)s попыток. Перед выходом в бой необходимо включить использование своих попыток над таблицей с результатами клана.');
        }

      case COMPETITION_METRIC.RIBBONS:
        {
          return x('Следующие %(dayCount)s дня соревнуйтесь с другим кланом в получении лент на кораблях разных классов и наций. Для этого у каждого игрока есть %(attemptCount)s попыток. Перед выходом в бой необходимо включить использование своих попыток над таблицей с результатами клана.');
        }

      default:
        {
          return '';
        }

    }
  };

  renderShortRules = () => {

    let oilReward = this.getPreparationRewardSumm();
    if (oilReward === 0) {
      oilReward = 800;
    }

    return <Fragment>
                <StepCSSTransitionGroup level={1}>
                    <h1 className={styles.bigTitle}>{t('Как играть в морское сражение')}</h1>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={2}>
                    <div className={styles.step}>
                        <div className={`${styles.stepImage} ${styles.stepImageFirst}`} />
                        <span className={styles.paragraphTitle}>{t('Подготовка')}</span>
                        <Interpolate parent={'p'} className={styles.paragraphText} i18nKey={x('Первые %(dayCount)s дня "Морского сражения" играйте в привычных боях. Выполните клановую задачу, получите доступ к Битве и %(reward)s')} dayCount={4} reward={<Currency amount={oilReward} type={'oil'} isBold={true} t={t} />} />
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={3}>
                    <div className={styles.step}>
                        <div className={`${styles.stepImage} ${styles.stepImageSecond}`} />
                        <span className={styles.paragraphTitle}>{t('Битва')}</span>
                        <Interpolate parent={'p'} className={styles.paragraphText} i18nKey={this.getBattleDescrText()} dayCount={3} attemptCount={10} />
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={4}>
                    <div className={styles.step}>
                        <div className={`${styles.stepImage} ${styles.stepImageThird}`} />
                        <span className={styles.paragraphTitle}>{t('Награды и рейтинг')}</span>
                        <p className={styles.paragraphText}>{t('Все кланы, участвующие в Морском сражении, получают нефть в качестве награды и продвижение в рейтинге.')}</p>
                    </div>
                </StepCSSTransitionGroup>
            </Fragment>;
  };

  renderJoinClan = () => {
    return <Fragment>
                <StepCSSTransitionGroup level={3}>
                    <h2 className={styles.title}>{t('Для участия в морском сражении необходимо состоять в клане')}</h2>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={3}>
                    <div className={styles.center}>
                        <ButtonPromo isCenter onClick={this.props.navigateToRecommendations}>
                            {t('Хочу в клан')}
                        </ButtonPromo>
                    </div>
                </StepCSSTransitionGroup>
            </Fragment>;
  };

  render() {

    const hasNoClan = this.props.clanId === undefined || this.props.clanId === null;

    return <div className={styles.wrapper}>
                {this.renderShortRules()}

                {this.state.isFullRules ? this.renderFullRules() : <div className={styles.showFullLink}>
                        <StepCSSTransitionGroup level={3}>
                            <Link isActionLink onClick={this.showFullRules} arrow={''}>
                                {t('Расширенный вариант правил')}
                            </Link>
                        </StepCSSTransitionGroup>
                    </div>}

                {hasNoClan ? this.renderJoinClan() : null}
            </div>;

  }
}

export default RulesTab;